import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  CircularProgress,
  Chip,
  IconButton,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { ViewIcon } from '../../components/shared/Icons';
import axios from 'axios';

interface FormResponse {
  id: string;
  formId: string;
  createdAt: string;
  data: any;
}

export const ResponsesList: React.FC = () => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const navigate = useNavigate();
  const [responses, setResponses] = useState<FormResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResponses = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `/api/tenant/${tenantId}/form-responses`
        );
        setResponses(response.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchResponses();
  }, [tenantId]);

  const handleViewResponse = (responseId: string) => {
    navigate(`/tenant/${tenantId}/response/${responseId}`);
  };

  if (loading) {
    return (
      <Container maxWidth={false} sx={{ py: 4, px: 0, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth={false} sx={{ py: 4, px: 0 }}>
      <Paper sx={{ p: 3, px: 4, borderRadius: 0 }}>
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton onClick={() => navigate(`/tenant/${tenantId}/forms`)}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4">Form Responses</Typography>
        </Box>
        {responses.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h6" color="text.secondary">
              No responses submitted yet
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Form submissions will appear here
            </Typography>
          </Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Form Name</TableCell>
                  <TableCell>Submitted At</TableCell>
                  <TableCell>Response ID</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {responses.map((response) => (
                  <TableRow key={response.id} hover>
                  <TableCell>
                    <Typography variant="body1" fontWeight="medium">
                      {response.formId}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {new Date(response.createdAt).toLocaleString()}
                  </TableCell>
                    <TableCell>
                      <Chip label={response.id} size="small" />
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<ViewIcon color="currentColor" />}
                        onClick={() => handleViewResponse(response.id)}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Container>
  );
};

